<script setup lang="ts">
import { provide } from 'vue';

import App from './App.vue';
import { useAuthStore } from '@app/stores/auth';
import { authInjectionKey } from '@shared/context/injectionKeys';

provide(authInjectionKey, useAuthStore());
</script>

<template>
  <App />
</template>
